import React, { useEffect, useState } from 'react';
import { Button, FlexDirectionRow, MainContent, SubTitle } from "../../../../../components/StyledComponents";
import { Grid } from "@mui/material";
import { valueIsRequired } from "../../../../../utils/regex";
import { useApp } from "../../../../../context/app";
import { useForm } from "react-hook-form";
import Spinner from "react-spinner-material";
import { handleModalStatus } from "../../../../../utils/handleModalStatus";
import { BaSeDialogContext } from "@base/react";
import { ManutencaoService } from "../../../services/manutencaoService";
import TextArea from "../../../../../components/TextArea";
import Select from "../../../../../components/Select";
import { UserActionsContent } from "../../../../../components/UserActionsContent";
import InputControlled from "../../../../../components/InputControlled";

export const Incluir = () => {

    const {showModal} = React.useContext(BaSeDialogContext);
    const {setRenderIncludeScreen, manageItem} = useApp();
    const {setValue, control, handleSubmit, reset, watch} = useForm({
        defaultValues: {
            servico: '',
            horaInicio: '',
            horaFim: '',
            motivo: '',
            diario: false,
            descricao: '',
        }
    });
    const [isSubmited, setIsSubmited] = useState(false);

    const diarioWatch = watch('diario');

    useEffect(() => {
        const {data} = manageItem;
        if (data?.id) {
            reset(data);
        }
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [manageItem]);


    useEffect(() => {
        if (diarioWatch === true) {
            setValue('horaInicio', '00:00');
            setValue('horaFim', '00:00');
        } else {
            setValue('horaInicio', '');
            setValue('horaFim', '');
        }
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [diarioWatch]);

    const onResetFields = () => {
        reset();
    }

    const submitForm = async (dataForm) => {
        setIsSubmited(true);
        dataForm.horaInicio = dataForm.horaInicio +':00'
        dataForm.horaFim = dataForm.horaFim +':00'
        if (dataForm.id) {
            await editItem(dataForm);
            return;
        }
        await createItem(dataForm);
    }

    const handleGoHome = () => {
        setRenderIncludeScreen(false);
    };

    const createItem = async (dataForm) => {
        ManutencaoService.save(dataForm)
            .then(() => {
                handleModalStatus({
                    type: "success",
                    msgOnSuccess: "A manutenção foi cadastrado com sucesso.",
                    onCloseModal: handleGoHome,
                    showModal,
                });
            })
            .catch((error) => {
                handleModalStatus({
                    type: "error",
                    msgOnError:
                        error?.response?.data?.message ??
                        "A manutenção não foi cadastrado. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
                    showModal,
                })
            })
            .finally(() => {
                setIsSubmited(false);
            })
    }

    const editItem = async (dataForm) => {
        ManutencaoService.update(dataForm)
            .then(() => {
                handleModalStatus({
                    type: "success",
                    msgOnSuccess: "A manutenção foi atualizada com sucesso.",
                    onCloseModal: handleGoHome,
                    showModal,
                });
            })
            .catch((error) => {
                handleModalStatus({
                    type: "error",
                    msgOnError:
                        error?.response?.data?.message ??
                        "A manutenção não foi atualizada. Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.",
                    showModal,
                })
            })
            .finally(() => {
                setIsSubmited(false);
            })
    }

    const opcoesServicos = {
        'NA_PALMA_DA_MAO': 'App Sebrae',
        'NA_PALMA_ADM': 'Admin'
    }

    return (
        <>
            <MainContent>
                <SubTitle>
                    <h3>{manageItem?.data?.id ? "Editar" : "Incluir"}</h3>
                </SubTitle>

                <Grid
                    container
                    item
                    flexDirection={'columm'}
                >

                    <Grid item md={7}>
                        <Grid item md={2}>
                            <Select
                                formatOptionLabel={(value) => opcoesServicos[value]}
                                defaultName={'label'}
                                options={['NA_PALMA_DA_MAO', 'NA_PALMA_ADM']}
                                name="servico"
                                control={control}
                                rules={{...valueIsRequired()}}
                                placeholder="Serviço"
                            />

                        </Grid>
                    </Grid>

                    <Grid item md={7}>
                        <Grid item md={2}>
                            <Select
                                formatValueOnChange={(value) => JSON.parse(value)}
                                formatOptionLabel={(value) => value ? 'Sim' : 'Não'}
                                options={[true, false]}
                                name="diario"
                                control={control}
                                placeholder="Diário"
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} md={6}>
                        <Grid item md={3}>
                            <InputControlled
                                type={'time'}
                                name="horaInicio"
                                control={control}
                                placeholder="Hora Início"
                                maxLength={140}
                                showMaxLengthLabel={false}
                                rules={{...valueIsRequired()}}
                            />
                        </Grid>
                        <Grid item md={3}>
                            <InputControlled
                                type={'time'}
                                name="horaFim"
                                control={control}
                                placeholder="Hora Fim"
                                maxLength={140}
                                showMaxLengthLabel={false}
                                rules={{...valueIsRequired()}}
                            />
                        </Grid>
                    </Grid>

                    <Grid item md={7}>
                        <TextArea
                            name="motivo"
                            control={control}
                            rules={{...valueIsRequired()}}
                            placeholder="Motivo"
                            showMaxLengthLabel={true}
                            maxLength={1000}
                        />

                    </Grid>
                    <Grid item md={7}>
                        <TextArea
                            name="descricao"
                            control={control}
                            rules={{...valueIsRequired()}}
                            placeholder="Mensagem"
                            showMaxLengthLabel={true}
                            maxLength={1000}
                        />
                    </Grid>
                </Grid>


                <Grid container justifyContent="flex-end">
                    <Grid item>
                        <FlexDirectionRow position={"end"}>
                            {
                                !manageItem?.data?.id &&
                                <Button
                                    href="#"
                                    backgroundColor={"#9CA2A8"}
                                    onClick={onResetFields}
                                >
                                    Limpar
                                </Button>
                            }

                            <div style={{marginLeft: "10px", marginRight: "10px"}}/>
                            <Button
                                href="#"
                                disabled={isSubmited}
                                onClick={handleSubmit(submitForm)}
                            >
                                {isSubmited ? (
                                    <Spinner radius={16} color={"#fff"} stroke={2} visible={true}/>
                                ) : (
                                    manageItem?.data?.id ? "Editar" : "Incluir"
                                )}
                            </Button>
                        </FlexDirectionRow>
                    </Grid>
                </Grid>
            </MainContent>
            {manageItem?.data?.id && <UserActionsContent data={manageItem?.data}/>}
        </>
    )
}
